import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';
import { ApiService } from './services/api.service';
import { AuthorizeService } from './services/authorize.service';
import { HttpErrorHandler } from './services/http-error-handler.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationInterceptor } from './interceptors/application.interceptor';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { WorkspaceInterceptor } from './interceptors/workspace.interceptor';
import { AuthorizeGuard } from './guards/authorize.guard';
import { ConfigService } from 'src/env/config.service';
import { AuthConfig, OAuthModule, OAuthModuleConfig, OAuthStorage } from 'angular-oauth2-oidc';
import {
  authAppInitializerFactory,
  authConfigFactory,
  oauthModuleConfigFactory,
  storageFactory,
} from './components/api-authorization/auth-app-initializer.factory';
import { ShouldLoginComponent } from './components/should-login/should-login.component';
import { TranslateModule } from '@ngx-translate/core';
import { HeadersInterceptor } from './interceptors/headers.interceptor';
import { RightsGuard } from './guards/rights.guard';
import { InvalidAccountComponent } from './components/invalid-account/invalid-account.component';
import { InvalidAccountGuard } from './guards/invalid-account.guard';
import { UnauthorizedAccessComponent } from './components/unauthorized-access/unauthorized-access.component';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';
import { StartupService } from './services/startup.service';

@NgModule({
  declarations: [ShouldLoginComponent, InvalidAccountComponent, UnauthorizedAccessComponent, CustomToastComponent],
  imports: [
    BrowserModule,
    ToastrModule.forRoot({
      closeButton: true,
      toastComponent: CustomToastComponent,
    }),
    BrowserAnimationsModule,
    OAuthModule.forRoot(),
    TranslateModule.forChild(),
    ComponentsModule,
  ],
  providers: [
    AuthorizeService,
    StartupService,
    ApiService,
    HttpErrorHandler,
    AuthorizeGuard,
    RightsGuard,
    InvalidAccountGuard,
    ConfigService,
    {
      provide: AuthConfig,
      useFactory: authConfigFactory,
      deps: [ConfigService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authAppInitializerFactory,
      deps: [AuthorizeService],
      multi: true,
    },
    {
      provide: AuthConfig,
      useFactory: authConfigFactory,
      deps: [ConfigService],
    },
    {
      provide: OAuthModuleConfig,
      useFactory: oauthModuleConfigFactory,
      deps: [ConfigService],
    },
    { provide: OAuthStorage, useFactory: storageFactory },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApplicationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: WorkspaceInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
